var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ds-control ds-form-item" }, [
    _vm.isDesign || _vm.sPID
      ? _c(
          "div",
          {
            staticClass: "ds-flowprocess",
            class: { "is-vertical": _vm.isVertical },
          },
          [
            !_vm.hideTitle || !_vm.hideCheckbox
              ? _c("div", { staticClass: "head" }, [
                  !_vm.hideTitle
                    ? _c("div", { staticClass: "title" }, [
                        _c(
                          "label",
                          {
                            staticClass: "ds-font-3",
                            attrs: { handler: "title" },
                          },
                          [_vm._v(_vm._s(_vm.title))]
                        ),
                      ])
                    : _vm._e(),
                  !_vm.hideCheckbox && !_vm.isVertical
                    ? _c(
                        "div",
                        { staticClass: "set" },
                        [
                          _c("el-checkbox", {
                            attrs: { label: "隐藏异常环节" },
                            model: {
                              value: _vm.isHideNode,
                              callback: function ($$v) {
                                _vm.isHideNode = $$v
                              },
                              expression: "isHideNode",
                            },
                          }),
                          _c("el-checkbox", {
                            attrs: { label: "隐藏无意见环节" },
                            model: {
                              value: _vm.isHideYj,
                              callback: function ($$v) {
                                _vm.isHideYj = $$v
                              },
                              expression: "isHideYj",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.hideCheckbox && _vm.isVertical
                    ? _c(
                        "div",
                        { staticClass: "set" },
                        [
                          _c("el-switch", {
                            staticClass: "error",
                            attrs: { "active-text": "异常环节" },
                            model: {
                              value: _vm.isHideNode,
                              callback: function ($$v) {
                                _vm.isHideNode = $$v
                              },
                              expression: "isHideNode",
                            },
                          }),
                          _c("el-switch", {
                            attrs: { "active-text": "空意见环节" },
                            model: {
                              value: _vm.isHideYj,
                              callback: function ($$v) {
                                _vm.isHideYj = $$v
                              },
                              expression: "isHideYj",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "content", attrs: { handler: "content" } },
              _vm._l(_vm.data, function (item, index) {
                return _c("div", { key: index, staticClass: "item" }, [
                  _c("div", { staticClass: "fl-box" }, [
                    !_vm.isVertical
                      ? _c("span", [_vm._v(_vm._s(item.reachtime))])
                      : _vm._e(),
                    _vm.isVertical
                      ? _c("span", { staticClass: "node-name" }, [
                          _vm._v(_vm._s(item.nodename)),
                        ])
                      : _vm._e(),
                    _c("img", {
                      staticClass: "tx",
                      attrs: {
                        src: require("_platform/assets/styles/themes/workFlow/head_logo.png"),
                      },
                    }),
                    _c("img", {
                      staticClass: "icon",
                      attrs: {
                        src: require("_platform/assets/styles/themes/workFlow/status" +
                          _vm.getStatus(item.STATUS) +
                          ".png"),
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "fr-box",
                      class: { end: item.nodetype === "299" },
                    },
                    [
                      _c("div", { staticClass: "des" }, [
                        !_vm.isVertical
                          ? _c("div", [
                              _c("span", [_vm._v("处理环节：")]),
                              _c("span", [_vm._v(_vm._s(item.nodename))]),
                            ])
                          : _vm._e(),
                        item.nodetype !== "299"
                          ? _c("div", [
                              _c("span", [_vm._v("处理人：")]),
                              _c("span", [_vm._v(_vm._s(item.rusername))]),
                            ])
                          : _vm._e(),
                        _vm.isVertical
                          ? _c("div", [
                              _c("span", [_vm._v("接收时间：")]),
                              _c("span", [_vm._v(_vm._s(item.reachtime))]),
                            ])
                          : _vm._e(),
                        item.nodetype !== "299"
                          ? _c("div", [
                              _c("span", [_vm._v("签收时间：")]),
                              _c("span", [_vm._v(_vm._s(item.receivetime))]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.showResult && item.nodetype !== "299"
                        ? _c("div", { staticClass: "result" }, [
                            _c("div", [
                              _c("span", [_vm._v("处理结果：")]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.results[item.EXSTATUS])),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.showOpinion && _vm.showOpinion(item)
                        ? _c("div", { staticClass: "yj" }, [
                            _c("div", [
                              _c("span", [_vm._v("处理意见：")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (item.opinionatts &&
                                      item.opinionatts.Content) ||
                                      _vm.processingOpinion
                                  )
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.showFileList(item)
                        ? _c("DsfFlowFileList", {
                            attrs: {
                              attachments: item.opinionatts.Attachments,
                              isVertical: _vm.isVertical,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }